<template>

  <v-card>


    <v-container class="container-background" fluid grid-list-md style="overflow-x:auto;">

      <v-layout row wrap>
        <v-flex>
          <center>
          <table class="periodic_table">
            <tr v-for="(row,i) in periodic_table" :key="i">
              <td v-for="(col,ii) in row" :key="ii" :class="col.type" @click="cell_onClick(col.url)" :colspan="col.colspan">
                <template v-if="col.type=='table_title'">
                  <span style="font-size: 45px; text-align: center; font-weight: 800;">GLOBAL LOCAL LABORATORIES</span>
                </template>
                <template v-else-if="col.type=='image'">
                  <span><v-img src="/assets/img/lms_logo.png"></v-img></span>
                </template>
                <template v-else>
                  <span class="atomicNo">{{ col.atomicNo }}</span><v-spacer></v-spacer>
                  <span class="symbol">{{ col.symbol }}</span><v-spacer></v-spacer>
                  <span class="country">{{ col.country }}</span><v-spacer></v-spacer>
                  <span class="code">{{ col.code }}</span><v-spacer></v-spacer>
                </template>
              </td>
            </tr>
          </table>
          </center>
        </v-flex>
      </v-layout>
      
    </v-container>
  </v-card>

  
</template>

<script>
import auth from "../../functions/auth";
// import common from "../../functions/general";
// import qb from "../../functions/query.builder";

export default {
  name: "LMS_listing",
  components: {
  },
  data() {
    return {
      username: "",
      periodic_table: [
        [
          {
              atomicNo: "1",
              symbol: "Hq",
              country: "Malaysia",
              code: "MYHQ",
              type: "ent",
              url: "http://hq.lms.solutions/",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "table_title",
              url: "",
              colspan: "16"
          },
          {
              atomicNo: "2",
              symbol: "Pg",
              country: "Malaysia",
              code: "MYPG",
              type: "ent",
              url: "http://pr.lms.solutions/",
              colspan: "0"
          }
        ],
        [
          {
              atomicNo: "3",
              symbol: "Kl",
              country: "Malaysia",
              code: "MYKL",
              type: "ent",
              url: "http://sa.lms.solutions/",
              colspan: "0"
          },
          {
              atomicNo: "4",
              symbol: "Jb",
              country: "Malaysia",
              code: "MYJB",
              type: "ent",
              url: "http://jb.lms.solutions/",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "image",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "1",
              symbol: "Hq",
              country: "Malaysia",
              code: "MYHQ",
              type: "ent",
              url: "http://hq.lms.solutions/",
              colspan: "0"
          },
          {
              atomicNo: "Laboratory Number",
              symbol: "Symbol",
              country: "Country",
              code: "Code",
              type: "display_left_black",
              url: "",
              colspan: "2"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "5",
              symbol: "Us",
              country: "USA",
              code: "MYUS",
              type: "ent",
              url: "http://prco2.gotdns.com:7104/",
              colspan: "0"
          },
          {
              atomicNo: "6",
              symbol: "Sg",
              country: "Singapore",
              code: "MYSG",
              type: "ent",
              url: "http://sg.lms.solutions/",
              colspan: "0"
          },
          {
              atomicNo: "7",
              symbol: "Uq",
              country: "Malaysia",
              code: "Unipeq",
              type: "biz",
              url: "https://unipeq.lms.solutions/",
              colspan: "0"
          },
          {
              atomicNo: "8",
              symbol: "Kc",
              country: "Malaysia",
              code: "TNT",
              type: "biz",
              url: "https://tnt.lms.solutions/",
              colspan: "0"
          },
          {
              atomicNo: "9",
              symbol: "Ec",
              country: "Malaysia",
              code: "MYEC",
              type: "ent",
              url: "https://ec.lms.solutions/",
              colspan: "0"
          },
          {
              atomicNo: "10",
              symbol: "Ct",
              country: "Malaysia",
              code: "MYCT",
              type: "ent",
              url: "https://ct.lms.solutions/",
              colspan: "0"
          }
        ],
        [
          {
              atomicNo: "11",
              symbol: "Ps",
              country: "Malaysia",
              code: "PRIS",
              type: "ent",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "12",
              symbol: "Hk",
              country: "China",
              code: "ACHK",
              type: "ent",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "13",
              symbol: "Sh",
              country: "China",
              code: "ACSH",
              type: "ent",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "14",
              symbol: "Hn",
              country: "China",
              code: "ACHN",
              type: "ent",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "15",
              symbol: "Pg",
              country: "Phosphorus",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "16",
              symbol: "Sg",
              country: "Sulfur",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "17",
              symbol: "Cl",
              country: "Chlorine",
              code: "Gas",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "18",
              symbol: "Ar",
              country: "Argon",
              code: "Gas",
              type: "inactive",
              url: "",
              colspan: "0"
          }
        ],
        [
          {
              atomicNo: "19",
              symbol: "K",
              country: "Potassium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "20",
              symbol: "Ca",
              country: "Calcium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "21",
              symbol: "Sc",
              country: "Scandium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "22",
              symbol: "Ti",
              country: "Titanium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "23",
              symbol: "V",
              country: "Vanadium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "24",
              symbol: "Cr",
              country: "Chromium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "25",
              symbol: "Mn",
              country: "Maganese",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "26",
              symbol: "Fe",
              country: "Iron",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "27",
              symbol: "Co",
              country: "Cobalt",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "28",
              symbol: "Ni",
              country: "Nickel",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "29",
              symbol: "Cu",
              country: "Copper",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "30",
              symbol: "Zn",
              country: "Zinc",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "31",
              symbol: "Ga",
              country: "Gallium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "32",
              symbol: "Ge",
              country: "Germanium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "33",
              symbol: "As",
              country: "Arsenic",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "34",
              symbol: "Se",
              country: "Selenium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "35",
              symbol: "Br",
              country: "Bromine",
              code: "Liquid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "36",
              symbol: "Kr",
              country: "Krypton",
              code: "Gas",
              type: "inactive",
              url: "",
              colspan: "0"
          }
        ],
        [
          {
              atomicNo: "37",
              symbol: "Rb",
              country: "Rubidium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "38",
              symbol: "Sr",
              country: "Strontium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "39",
              symbol: "Y",
              country: "Yttrium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "40",
              symbol: "Zr",
              country: "Zirconium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "41",
              symbol: "Nb",
              country: "Niobium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "42",
              symbol: "Mo",
              country: "Molybdenum",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "43",
              symbol: "Tc",
              country: "Technetium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "44",
              symbol: "Ru",
              country: "Ruthenium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "45",
              symbol: "Rh",
              country: "Rhodium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "46",
              symbol: "Pd",
              country: "Palladium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "47",
              symbol: "Ag",
              country: "Silver",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "48",
              symbol: "Cd",
              country: "Cadmium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "49",
              symbol: "In",
              country: "Indium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "50",
              symbol: "Sn",
              country: "Tin",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "51",
              symbol: "Sb",
              country: "Antimony",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "52",
              symbol: "Te",
              country: "Tellurium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "53",
              symbol: "In",
              country: "Iodine",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "54",
              symbol: "Xe",
              country: "Xenon",
              code: "Gas",
              type: "inactive",
              url: "",
              colspan: "0"
          }
        ],
        [
          {
              atomicNo: "55",
              symbol: "Cs",
              country: "Cesium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "56",
              symbol: "Ba",
              country: "Barium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "*",
              country: "",
              code: "",
              type: "display_center",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "72",
              symbol: "Hf",
              country: "Hafnium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "73",
              symbol: "Ta",
              country: "Tantalum",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "74",
              symbol: "W",
              country: "Tungsten",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "75",
              symbol: "Re",
              country: "Rhenium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "76",
              symbol: "Os",
              country: "Osmium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "77",
              symbol: "Ir",
              country: "Iridium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "78",
              symbol: "Pt",
              country: "Platinum",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "79",
              symbol: "Au",
              country: "Gold",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "80",
              symbol: "Hg",
              country: "Mercury",
              code: "Liquid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "81",
              symbol: "Tl",
              country: "Thallium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "82",
              symbol: "Pb",
              country: "Lead",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "83",
              symbol: "Bi",
              country: "Bismuth",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "84",
              symbol: "Po",
              country: "Polonium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "85",
              symbol: "At",
              country: "Astatine",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "86",
              symbol: "Rn",
              country: "Radon",
              code: "Gas",
              type: "inactive",
              url: "",
              colspan: "0"
          }
        ],
        [
          {
              atomicNo: "87",
              symbol: "Fr",
              country: "Francium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "88",
              symbol: "Ra",
              country: "Radium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "**",
              country: "",
              code: "",
              type: "display_center",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "104",
              symbol: "Rf",
              country: "Rutherfordium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "105",
              symbol: "Db",
              country: "Dubnium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "106",
              symbol: "Sg",
              country: "Seaborgium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "107",
              symbol: "Bh",
              country: "Bohrium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "108",
              symbol: "Hs",
              country: "Hassium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "109",
              symbol: "Mt",
              country: "Meitnerium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "110",
              symbol: "Ds",
              country: "Darmstadtium",
              code: "Solid (Expected)",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "111",
              symbol: "Rg",
              country: "Roentgenium",
              code: "Solid (Expected)",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "112",
              symbol: "Cn",
              country: "Copernicium",
              code: "Solid (Expected)",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "113",
              symbol: "Nh",
              country: "Nihomium",
              code: "Solid (Expected)",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "114",
              symbol: "Fl",
              country: "Flerovium",
              code: "Solid (Expected)",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "115",
              symbol: "Mc",
              country: "Moscovium",
              code: "Solid (Expected)",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "116",
              symbol: "Lv",
              country: "Livermorium",
              code: "Solid (Expected)",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "117",
              symbol: "Ts",
              country: "Tennessine",
              code: "Solid (Expected)",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "118",
              symbol: "Og",
              country: "Oganesson",
              code: "Gas (Expected)",
              type: "inactive",
              url: "",
              colspan: "0"
          }
        ],
        [
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "*",
              country: "",
              code: "",
              type: "display_right",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "57",
              symbol: "La",
              country: "Lanthanum",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "58",
              symbol: "Ce",
              country: "Cerium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "59",
              symbol: "Pr",
              country: "Praseodymium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "60",
              symbol: "Nd",
              country: "Neodymium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "61",
              symbol: "Pm",
              country: "Promethium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "62",
              symbol: "Sm",
              country: "Samarium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "63",
              symbol: "Eu",
              country: "Europium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "64",
              symbol: "Gd",
              country: "Gadolinium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "65",
              symbol: "Tb",
              country: "Terbium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "66",
              symbol: "Dy",
              country: "Dysprosium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "67",
              symbol: "Ho",
              country: "Holmium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "68",
              symbol: "Er",
              country: "Erbium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "69",
              symbol: "Tm",
              country: "Thulium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "70",
              symbol: "Yb",
              country: "Ytterbium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "71",
              symbol: "Lu",
              country: "Luteium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          }
        ],
        [
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "",
              country: "",
              code: "",
              type: "",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "",
              symbol: "**",
              country: "",
              code: "",
              type: "display_right",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "89",
              symbol: "Ac",
              country: "Actinium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "90",
              symbol: "Th",
              country: "Thorium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "91",
              symbol: "Pa",
              country: "Protactinium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "92",
              symbol: "U",
              country: "Uranium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "93",
              symbol: "Np",
              country: "Neptunium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "94",
              symbol: "Pu",
              country: "Plutonium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "95",
              symbol: "Am",
              country: "Americium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "96",
              symbol: "Cm",
              country: "Curium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "97",
              symbol: "Bk",
              country: "Berkelium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "98",
              symbol: "Cf",
              country: "Californium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "99",
              symbol: "Es",
              country: "Einsteinium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "100",
              symbol: "Fm",
              country: "Fermium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "101",
              symbol: "Md",
              country: "Mendelevium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "102",
              symbol: "No",
              country: "Nobelium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          },
          {
              atomicNo: "103",
              symbol: "Lr",
              country: "Lawrencium",
              code: "Solid",
              type: "inactive",
              url: "",
              colspan: "0"
          }
        ]
      ]
    }
  },
  watch: {
  },
  created (){
    let self = this;
    auth.onChange = async function(blSignIn) {
      self.signedIn = blSignIn;

      if (blSignIn) {
        self.username = auth.getUsername();
      } else {
        self.$router.push({ path: "/login" });
      }
    };
    auth.hideHeader(false);
  },
  methods: {
    // logout() {
    //   auth.logout();
    // },
    // viewMenu() {
    //   this.showMenu = true; 
    // },
    // main_menu_onClick(action_name) {
    //   this.$router.push({ path: action_name });
    //   auth.hideHeader(false);
    // },
    cell_onClick(data) {
      if (data) {
        window.open(data);
      }
    }
  },
  mounted() {
    this.username = auth.getUsername();
  }
};
</script>

<style scoped>
  .disabled{
    color: grey;
    pointer-events: none;
  }
  a{
    text-decoration: none;
  }

  /* .periodic_table, .periodic_table tr, .periodic_table td{
    border: 1px solid black;
  } */
  /* .periodic_table {} */

  .periodic_table tr, td {padding: 5px;}
  .periodic_table td {
    width:90px;
    /* padding: 5px 5px 5px 5px; */
    font-family: roboto;
    text-align: center;
    line-height: 1.2em;    
  }

  .periodic_table td::before {
    filter: blur(100px);
  }

  /* .container-background {background-image:url(/assets/img/lms_logo_big.png); background-position: center; background-attachment: fixed;} */

  .periodic_table .ent {background-color: rgba(202, 255, 255, 0.7); cursor:pointer; border: 1px solid #a4dada;}
  .periodic_table .biz {background-color: rgba(	255, 201, 201, 0.7); cursor:pointer; border: 1px solid #d6a3a3;}
  .periodic_table .inactive {background-color: rgba(	242, 242, 243, 0.7); color: grey; border: 1px solid rgb(196, 195, 195);}
  .periodic_table .display_center {color: grey;}
  .periodic_table .display_right {color: grey; text-align: right;}
  .periodic_table .display_left {color: grey; text-align: left;}
  .periodic_table .display_left_black {text-align: left;}

  .periodic_table .atomicNo {font-size: 12px;}
  .periodic_table .symbol {font-size: 20px; font-weight: bold;}
  .periodic_table .country {font-size: 11px;}
  .periodic_table .code {font-size: 11px;}

  .sample .atomicNo {font-size: 12px;}
  .sample .symbol {font-size: 20px; font-weight: bold;}
  .sample .country {font-size: 11px;}
  .sample .code {font-size: 11px;}
  
</style>
